const API_BASE = {
    url: "https://omnichannelb2b.nzttool.it/apisrc/public/api/",
    // url: "http://localhost/nztb2b/nztb2b_back/public/api/",
}

export default API_BASE;